<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>ALL PERMISSIONS</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
            <th>Permissions</th>
            <span :key="indextr" v-for="(tr, indextr) in permissions" >
             <span><vs-chip closable @click="deletePermission(tr.id)">{{tr.name}}</vs-chip></span>
            </span>        
        </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <!-- <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button> -->
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {ALL_PERMISSIONS, UPDATE_ROLE_PERMISSION, REMOVE_PERMISSION } from '@/graphql'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {

      dataId: null,
      dataName:null,
      dataPermission:null,
      permissions:[],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      deleteItem:null
    }
  },
  watch: {
    isSidebarActive (val) {
      this.get()
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {} = JSON.parse(JSON.stringify(this.data))
     
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataPermission
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    deletePermission (val) {
      this.deleteItem = val 
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'You are about to permanently delete',
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      this.$apollo
        .mutate({
          mutation: REMOVE_PERMISSION,
          variables: {
            id: this.deleteItem
          }
        })
        .then(response => {
          this.get()
          if (response.data.removePermission.status == 'Success') {
            this.StatusSuccess(response.data.removePermission.message, response.data.removePermission.color)
            this.$emit('closeSidebar')
          } else {
            this.StatusSuccess(response.data.removePermission.message, response.data.removePermission.color)
          }
        }).catch(error => {
          console.log(error)
        })

    },
    StatusSuccess (msg, color) {
      this.$vs.notify({
        title: 'Permission',
        text: msg,
        color,
        position: 'top-right'
      })
    },
    StatusFail (msg) {
      this.$vs.notify({
        title: 'Permission',
        text: msg,
        color: 'danger',
        position: 'top-right'
      })
    },
    initValues () {
      this.dataId = null
      this.dataName = null
      this.dataPermission = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            const permisions = []
            console.log(this.dataPermission)
            for (let index = 0; index < this.dataPermission.length; index++) {
              permisions.push(this.dataPermission[index].id)
            }
            console.log(permisions)
            this.$apollo
              .mutate({
                mutation: UPDATE_ROLE_PERMISSION,
                variables: {
                  role_id:this.dataId,  
                  permission_id:permisions
                }
              })
              .then(response => {
                console.log(response)
                if (response.data.updateRolePermissions.status == 'Success') {
                  this.StatusSuccess(response.data.updateRolePermissions.message)
                  this.$emit('closeSidebar')
                  this.initValues()
                  this.$emit('getdata')
                } else {
                  this.StatusFail()
                }
              }).catch(error => {
                console.log(error)
                this.StatusFail()
              })
          } 
          // else {
          //     this.$apollo
          //       .mutate({
          //         mutation: ADD_NEW_PERMISSION,
          //         variables: {
          //           name:  this.dataName,
          //           display:  this.dataDisplayName,
          //           about:  this.dataAbout
          //         }
          //       })
          //       .then(response => {
          //         if (response.data.addNewPermission.status == 'Success') {
          //           this.StatusSuccess(response.data.addNewPermission.message)
          //           this.$emit('closeSidebar')
          //           this.initValues()
          //           this.$emit('getdata')
          //         }  
          //         if (response.data.addNewPermission.status == 'Failed') {
          //           this.StatusFail(response.data.addNewPermission.message)
          //         }
          //       }).catch(error => {
          //         console.log(error)
          //         this.StatusFail("Failed to Add")
          //       })

        //   }
        }
      })
    },
    get () {
      this.$apollo
        .mutate({
          mutation: ALL_PERMISSIONS
        })
        .then(response => {
          this.permissions = response.data.permissions
        })
    }
  },
  created () {
   

  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
<style >
.add-new-data-sidebar[data-v-51805451] .vs-sidebar--background {
    z-index: 9999;
}
</style>
